export default "__VITE_ASSET__LjIIq0CI__"